module.exports = __webpack_public_path__ + "static/media/11-7.49e664c2.mp3";